import React, { createRef, useEffect, useState } from "react";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../../api/apiUtil";
import Table from "../../../components/Table/Table";
import getToken, { redirectToLogin } from "../../getToken";
import authStore from "../../../store/authStore";
import api from "../../../api/api";
import "./productList.css";
import { DateRange } from "react-date-range";
import { format, parseISO } from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from "xlsx";
import excelIcon from "../../../images/icons/download.png";
import { message } from "antd";

const ProductReport = () => {
    const refReportTable = createRef();
    const [keyword, setKeyword] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    })
    const brandId = authStore((state) => state.auth?.brandId);

    const [reportList, setReportList] = useState({
        isLoading: true,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramReport, setParamReport] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
    });

    const retrieveReportList = async (value = paramReport) => {
        var request = {
            ...value,
            keyword: value.keyword || "",
            startDate: format(startDate, "yyyy-MM-dd"),
            endDate: format(endDate, "yyyy-MM-dd")
        };

        api
            .post("Admin/GetProductReport", request, getToken())
            .then((result) => {
                apiUtil.parseResult(
                    result,
                    (response) => {
                        const data = response.data.data;
                        if (response.data.code === 401) {
                            message.warning(response.data.message);
                            redirectToLogin();
                        } else if (response.data.code === 200) {
                            setReportList({
                                isLoading: false,
                                limit: 10,
                                data: data.data || [],
                                total: data.totalRecords,
                                page: data.paging,
                            });
                            setExcelData(response.data.data.data);
                        } else {
                            setReportList({
                                data: [],
                                total: 0,
                                page: 0,
                                limit: 0,
                                isLoading: false,
                            });
                        }
                    },
                    (error, type) => {
                        console.log(error);
                    }
                );
            });
    };

    const exportToExcel = async () => {
        try {
            const request = {
                ...paramReport,
                keyword,
                currentPage: 1,
                rowLimit: 100000,
                startDate: format(startDate, "yyyy-MM-dd"),
                endDate: format(endDate, "yyyy-MM-dd"),
            };

            const result = await api.post("Admin/GetProductReport", request, getToken());
            apiUtil.parseResult(
                result,
                (response) => {
                    const data = response.data.data.data || [];

                    const excelDataFormatted = data.map((row, index) => ({
                        No: index + 1,
                        Date: format(parseISO(row.reportDate), 'MM-dd-yyyy'),
                        Time: new Date(row.reportTime).toLocaleTimeString("en-US"),
                        Marker: row.markerName || "-",
                        Quantity: row.count,
                        Weight: row.weight,
                        Rate: row.rate,
                        Price: row.price,
                        "Carry Name": row.carryName || "-",
                        Note: row.description
                    }));

                    const fileName = "ကယ်ရီ စာရင်း.xlsx";
                    const ws = XLSX.utils.json_to_sheet(excelDataFormatted);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "ကယ်ရီ စာရင်း");

                    XLSX.writeFile(wb, fileName);
                });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
        }
    };

    useEffect(() => {
        retrieveReportList({
            ...paramReport,
            keyword
        });
    }, [paramReport.currentPage, startDate, endDate]);

    const handleDateRangeChange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setStartDate(startDate);
        setEndDate(endDate);
        setDateRange({ startDate, endDate });
        retrieveReportList();
    };

    const handleInputClick = () => {
        setShowDatePicker((prevState) => !prevState);
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!e.target.closest(".date-input-container")) {
                setShowDatePicker(false);
            }
        };

        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div className="Actions space_between">
                <h6 className="title_text mt-2">Product Report</h6>

                <div className="d-flex justify-content-end gap-16 align-items-center">
                    {/* Export to Excel */}
                    <div>
                        <button className="export-button" onClick={exportToExcel}>
                            <img src={excelIcon} className="icon" />
                            Export to Excel
                        </button>
                    </div>

                    {/* dateRangePicker */}
                    <div className="date-input-container ">
                        <input
                            type="text"
                            className="inputBox input-right-side_text "
                            value={`${format(dateRange.startDate, "yyyy MMM dd")} - ${format(
                                dateRange.endDate,
                                "yyyy MMM dd"
                            )}`}
                            readOnly
                            onClick={handleInputClick}
                        />
                        <img
                            src={calenderIcon}
                            className="iconDate"
                            onClick={handleInputClick}
                        />
                        {showDatePicker && (
                            <div className="input-dateRange">
                                <DateRange
                                    showDateDisplay={false}
                                    ranges={[{ startDate, endDate, key: "selection" }]}
                                    onChange={handleDateRangeChange}
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <CustomSearchBar
                            value={keyword}
                            setValue={setKeyword}
                            onSearch={(value) => retrieveReportList({
                                ...paramReport,
                                keyword: value || "",
                                currentPage: 1
                            })}
                        />
                    </div>
                </div>
            </div>

            <div className="table_container report_table">
                <Table
                    ref={refReportTable}
                    maxBodyHeight={reportList.limit * 100}
                    isLoading={reportList.isLoading}
                    grouping={reportList.grouping}
                    limit={reportList.limit}
                    page={reportList.page}
                    total={reportList.total}
                    data={reportList.data}
                    onPageChange={(page) => {
                        setParamReport({
                            ...paramReport,
                            currentPage: page,
                        });
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1,
                            width: "80px",
                        },
                        {
                            title: "Date",
                            render: (row) => {
                                return row.reportDate ? format(parseISO(row.reportDate), 'dd-MM-yyyy') : "-"
                            },
                            width: "150px",
                        },
                        {
                            title: "Time",
                            render: (row) => {
                                return row.reportTime ? new Date(row.reportTime).toLocaleTimeString('en-US') : "-"
                            },
                            width: "150px",
                        },
                        {
                            title: "Marker",
                            field: "markerName",
                            width: "100px",
                        },
                        {
                            title: "Quantity",
                            field: "count",
                            width: "100px",
                        },
                        {
                            title: "Weight (kg)",
                            field: "weight",
                            width: "150px",
                        },
                        {
                            title: "Rate",
                            field: "rate",
                            width: "150px",
                        },
                        {
                            title: "Price",
                            field: "price",
                            width: "150px",
                        },
                        {
                            title: "Carry Name",
                            field: "carryName",
                            width: "200px",
                        },
                        {
                            title: "Note",
                            field: "description",
                            width: "300px"
                        }
                    ]}
                />
            </div>
        </>
    );
}
export default ProductReport;